var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 16C3.59053 16 0 12.4096 0 8.00002C0 3.59056 3.59053 3.03196e-05 7.99998 3.03196e-05C10.1229 -0.00582903 12.16 0.83778 13.6572 2.34294L13.9285 2.61428L11.2334 5.30485L10.9619 5.03336C9.67758 3.75128 7.71399 3.44157 6.09737 4.26607C4.48074 5.09056 3.57854 6.86204 3.86244 8.65445C4.1462 10.4469 5.55161 11.8528 7.34388 12.1376C9.13614 12.4223 10.908 11.5211 11.7334 9.90487H7.61899V6.0953H15.7762L15.8381 6.39999C15.9454 6.92664 15.9997 7.46263 16 8.00002C16 12.4096 12.4096 16 7.99998 16ZM7.99998 0.762027C4.00948 0.762027 0.761857 4.00951 0.761857 8.00002C0.761857 11.9905 4.00948 15.2381 7.99998 15.2381C11.9905 15.2381 15.2381 11.9905 15.2381 8.00002C15.2378 7.61734 15.2076 7.23523 15.1476 6.85716H8.38098V9.14287H12.8476L12.6667 9.65236C11.9412 11.6977 9.96859 13.0325 7.80007 12.9452C5.63169 12.858 3.77273 11.3691 3.21386 9.27205C2.65499 7.1751 3.52664 4.95859 5.36397 3.80387C7.20144 2.64902 9.57671 2.82508 11.2238 4.23816L12.8429 2.61917C11.516 1.41869 9.78918 0.756446 7.99998 0.762027Z",
    fill: "#183243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSvg);
export default __webpack_public_path__ + "static/media/google_svg.3fec663d534cd8712fcbe84431505465.svg";
export { ForwardRef as ReactComponent };